import React from "react";
import PropTypes from "prop-types";
import ModalToBody from "../../../../base/ModalToBody";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ZONES_ACTIONS } from "../../../../redux/zones/actions";
import { selectZones } from "../../../../redux/zones/selectors";
import { getZones } from "../../../../services/api/zones";
import {
  addCrewMemberAccess,
  deleteCrewMemberAccess,
  getCrewMember
} from "../../../../services/api/crewMembers";
import { ajaxErrorHandler } from "../../../../libs/utils";
import moment from "moment";

class _CrewMemberZones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      allZones: [],
      accessZones: [],
      crewMember: undefined
    };

    this._hideModal = this._hideModal.bind(this);
    this._showModal = this._showModal.bind(this);
    this._handleClick = this._handleClick.bind(this);
  }

  static propTypes = {
    crewMember: PropTypes.object,
    event: PropTypes.object,
    loadZones: PropTypes.func,
    eventDays: PropTypes.array
  };

  _showModal() {
    document.body.classList.add("modal-open");
    getCrewMember(this.props.crewMember.id).then(response => {
      this.setState({
        crewMember: response,
        accessZones: response.profile.accesses.map(access => access.zoneId)
      });
    });

    getZones({
      "filter[venue_id]": this.props.event.venueId,
      "page[size]": 50
    }).then(response => {
      this.setState({
        allZones: response.data
      });
    });

    this.setState({
      showModal: true
    });
  }

  _hideModal() {
    document.body.classList.remove("modal-open");
    this.setState({
      showModal: false
    });
  }

  _handleClick(e, day, zoneId) {
    const action = e.target.checked
      ? addCrewMemberAccess
      : deleteCrewMemberAccess;

    action(this.props.crewMember.id, {
      day: day,
      zoneId: zoneId
    })
      .then(response => {
        getCrewMember(this.props.crewMember.id)
          .then(response => {
            this.setState({
              crewMember: response,
              accessZones: response.profile.accesses.map(
                access => access.zoneId
              )
            });
          })
          .catch(ajaxErrorHandler);
      })
      .catch(ajaxErrorHandler);
  }

  _rowToggle(e, days, zoneId) {
    const action = e.target.checked
      ? addCrewMemberAccess
      : deleteCrewMemberAccess;
    const crewMemberId = this.props.crewMember.id;
    const self = this;

    const newDays = days.filter(day => this.props.eventDays.indexOf(day) > -1);

    for (let i = 0; i < newDays.length; i++) {
      setTimeout(function() {
        action(crewMemberId, {
          day: newDays[i],
          zoneId: zoneId
        })
          .then(response => {
            if (i === newDays.length - 1) {
              getCrewMember(crewMemberId)
                .then(response => {
                  self.setState({
                    crewMember: response,
                    accessZones: response.profile.accesses.map(
                      access => access.zoneId
                    )
                  });
                })
                .catch(ajaxErrorHandler);
            }
          })
          .catch(ajaxErrorHandler);
      }, 100 * i);
    }
  }

  render() {
    const { showModal, allZones, accessZones, crewMember } = this.state;
    const { eventDays } = this.props;

    return [
      <span key="button">
        <button
          className="btn btn-outline-accent m-btn btn-sm  m-btn--icon m--margin-left-5"
          onClick={this._showModal}
        >
          <span>
            <i className="la la-map-marker" />
            <span>Zones</span>
          </span>
        </button>
      </span>,

      <ModalToBody key="modal" render={showModal}>
        <div
          className="modal fade show"
          id="m_modal_4"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          style={{
            display: showModal ? "block" : "none",
            zIndex: "1039"
          }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Overwrite Zones
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this._hideModal}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <table className="table table-bordered table-hover">
                  <thead>
                    <tr>
                      <th />
                      {crewMember &&
                        eventDays &&
                        crewMember.days.map(day => {
                          if (eventDays.indexOf(day) > -1) {
                            return (
                              <th key={day} className="m--align-center">
                                {moment(day).format("dd DD/MM")}
                              </th>
                            );
                          }

                          return null;
                        })}
                    </tr>
                  </thead>
                  <tbody>
                    {allZones.map(zone => (
                      <tr key={"row_" + zone.id}>
                        <th scope="row" style={{ whiteSpace: "nowrap" }}>
                          {accessZones.indexOf(zone.id) === -1 && (
                            <label
                              className="m-checkbox"
                              style={{ marginBottom: 0 }}
                            >
                              <input
                                type="checkbox"
                                onChange={e =>
                                  this._rowToggle(e, crewMember.days, zone.id)
                                }
                              />{" "}
                              &nbsp;
                              <span />
                            </label>
                          )}

                          {zone.name}
                        </th>
                        {crewMember &&
                          crewMember.days.map(day => {
                            if (eventDays.indexOf(day) > -1) {
                              return (
                                <td
                                  key={"row_" + zone.id + "_" + day}
                                  className="m--align-center"
                                >
                                  <div
                                    className="m-checkbox-list"
                                    style={{ display: "inline-block" }}
                                  >
                                    {accessZones.indexOf(zone.id) > -1 ? (
                                      <label
                                        className="m-checkbox m-checkbox--disabled"
                                        style={{
                                          opacity: 0.5,
                                          marginBottom: 0,
                                          paddingLeft: 18
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          disabled=""
                                          defaultChecked
                                        />{" "}
                                        &nbsp;
                                        <span />
                                      </label>
                                    ) : (
                                      <label
                                        className="m-checkbox"
                                        style={{
                                          marginBottom: 0,
                                          paddingLeft: 18
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          onChange={e =>
                                            this._handleClick(e, day, zone.id)
                                          }
                                          checked={
                                            crewMember.crewMemberAccesses.filter(
                                              access =>
                                                access.day === day &&
                                                access.zoneId === zone.id
                                            ).length > 0
                                          }
                                        />{" "}
                                        &nbsp;
                                        <span />
                                      </label>
                                    )}
                                  </div>
                                </td>
                              );
                            }

                            return null;
                          })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div
          className={"modal-backdrop fade " + (showModal ? " show" : "")}
          style={{
            display: showModal ? "block" : "none",
            zIndex: "1038"
          }}
        />
      </ModalToBody>
    ];
  }
}

const mapDispatchToProps = dispatch => ({
  loadZones: params => dispatch(ZONES_ACTIONS.loadAllRequest(params))
});

const mapStateToProps = function(state) {
  return {
    zones: selectZones(state)
  };
};

const CrewMemberZones = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(_CrewMemberZones)
);

export default CrewMemberZones;
